import React, { useState } from "react";
import { ClipboardDocumentIcon, CheckIcon, ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import Button from "src/components/form/Button";

const RecoveryCodeView = ({ disabled, code, onContinue, site }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="animate-2fa-fade w-full space-y-6 text-center">
      <div className="relative overflow-hidden rounded-xl border border-dashed border-gray-300 bg-gray-50 p-6">
        <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.15em] text-gray-400">Your Recovery Code</div>
        <div className="font-mono text-2xl font-bold tracking-wider text-gray-800">{code}</div>

        <button
          type="button"
          onClick={copyToClipboard}
          className="mt-4 flex w-full items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-widest text-highlightColor transition-opacity hover:opacity-80">
          {isCopied ? (
            <>
              <CheckIcon className="h-4 w-4" /> Copied to Clipboard
            </>
          ) : (
            <>
              <ClipboardDocumentIcon className="h-4 w-4" /> Copy Code
            </>
          )}
        </button>
      </div>

      <div className="flex gap-3 rounded-lg bg-amber-50 p-3 text-left">
        <ExclamationTriangleIcon className="h-5 w-5 shrink-0 text-amber-600" />
        <p className="text-[11px] leading-relaxed text-amber-800">
          <strong>Important:</strong> Save this code in a password manager or a safe place. This is the <strong>only</strong> way to regain access if you lose your device. It can only be used once.
        </p>
      </div>

      <div className="pt-2">
        <Button
          buttonClasses={"w-full"}
          buttonType={"button"}
          buttonLabel={"Continue"}
          buttonFunction={onContinue}
          isDisable={disabled}
          buttonStyles={{
            borderColor: site?.highlight_color,
            backgroundColor: site?.highlight_color,
          }}
        />
      </div>
    </div>
  );
};

export default RecoveryCodeView;
